import { Avatar as AvatarPrimitive } from "@base-ui/react/avatar";

import { cn } from "@/lib/utils";

import { initialsOf } from "./initials";

interface UserAvatarProps {
  src?: string;
  name?: string;
  className?: string;
}

/**
 * The signed-in user's avatar in the mobile chrome: their photo when they
 * have one, otherwise initials on a neutral grey (--chrome-avatar-*), never
 * the hashed colour the shared Avatar gives contacts.
 */
export const UserAvatar = ({ src, name, className }: UserAvatarProps) => (
  <AvatarPrimitive.Root
    data-slot="user-avatar"
    // Decorative: every place it appears is already labelled.
    aria-hidden
    className={cn(
      "relative flex shrink-0 overflow-hidden rounded-full bg-[var(--chrome-avatar-bg)] select-none",
      className,
    )}
  >
    <AvatarPrimitive.Image
      src={src}
      alt=""
      className="aspect-square size-full object-cover"
    />
    <AvatarPrimitive.Fallback className="flex size-full items-center justify-center font-semibold tracking-wide text-[var(--chrome-avatar-fg)]">
      {initialsOf(name)}
    </AvatarPrimitive.Fallback>
  </AvatarPrimitive.Root>
);
